"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ScreenshareStopShareToBreakoutOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ScreenshareStopShareToBreakoutOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.147 10.854a.5.5 0 0 1 0-.708L7.293 8 5.147 5.854a.5.5 0 1 1 .707-.708L8 7.293l2.146-2.147a.5.5 0 1 1 .708.708L8.707 8l2.147 2.146a.5.5 0 0 1-.707.708L8 8.707l-2.146 2.147a.5.5 0 0 1-.707 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 3V1a1 1 0 0 1 1-1H15a1 1 0 0 1 1 1v5.5a1 1 0 0 1-1 1h-2v1h2a1 1 0 0 1 1 1V15a1 1 0 0 1-1 1H9.5a1 1 0 0 1-1-1v-2h-1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V9.5a1 1 0 0 1 1-1h2v-1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h5.5a1 1 0 0 1 1 1v2h1Zm-2 0a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V1H15v5.5h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2V15H9.5v-2a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v2H1V9.5h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H1V1h5.5v2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ScreenshareStopShareToBreakoutOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ScreenshareStopShareToBreakoutOutline;
exports["default"] = _default;